import type { SourceBrowserbaseConfiguration } from "@gx/ts-contracts/services/source/resources/source_configuration/browserbase/browserbase_pb";

import type { CreateSourceState } from "@/pages/sources/components/create/sources/types";

export enum CreateSourceBrowserbasePhase {
  IDLE = "IDLE",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export type CreateSourceBrowserbaseState = CreateSourceState & {
  configuration: SourceBrowserbaseConfiguration;
  phase: CreateSourceBrowserbasePhase;
};
